import { Button, Col, Divider, Form, Input, Row, Select } from 'antd';
import { useAuth } from 'AuthContext'
import React, { useMemo, useState } from 'react'
import ChangePassword from './ChangePassword';
import Tuition from './Tuition';
import "./style.css"

const ROLES = [
    [0, "Admin"],
    [1, "Nhà trường"],
    [2, "Giảng viên"],
    [3, "Giáo vụ"],
    [100, "Sinh viên"]].map((item) => ({
    value: item[0], label: item[1]
}))


export default function Account({ view = false, showList, hideList, userProp }) {
    const { user: yourUser } = useAuth();
    const [openModel, setOpenModel] = useState(false);
    const user = useMemo(() => userProp || yourUser, [userProp, yourUser]);
    const data = useMemo(() => {
        if (!user) return user;
        const result = {...user};
        for (const name in user) {
            if (showList && !showList.includes(name)) {
                result[name] = "Thông tin ẩn";
            } else if (hideList && hideList.includes(name)) {
                result[name] = "Thông tin ẩn";
            }
        }
        return result;
    }, [user, showList, hideList])
    return <>
        <Divider>Thông tin cá nhân</Divider>
        <Form
            initialValues={data}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
        >
            <Row gutter={24}>
                <Col lg={12} md={24} sm={24}>
                    <Form.Item
                        label="Tên đăng nhập"
                        name="username"
                    >
                        <Input disabled style={{ color: "#424242" }} />
                    </Form.Item>
                </Col>
                <Col lg={12} md={24} sm={24}>
                    <Form.Item
                        label="MSSV"
                        name="student_number"
                    >
                        <Input disabled style={{ color: "#424242" }} />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col lg={12} md={24} sm={24}>
                    <Form.Item
                        label="Họ"
                        name="last_name"
                    >
                        <Input disabled style={{ color: "#424242" }} />
                    </Form.Item>
                </Col>
                <Col lg={12} md={24} sm={24}>
                    <Form.Item
                        label="Tên đệm và tên"
                        name="first_name"
                    >
                        <Input disabled style={{ color: "#424242" }} />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col lg={12} md={24} sm={24}>
                    <Form.Item
                        label="Email"
                        name="email"
                    >
                        <Input disabled style={{ color: "#424242" }} />
                    </Form.Item>
                </Col>
                <Col lg={12} md={24} sm={24} className='select-disable-color-view'>
                    <Form.Item
                        label="Vai trò"
                        name="role"
                    >
                        <Select options={ROLES} disabled style={{ color: "#424242" }} />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col lg={12} md={24} sm={24}>
                    <Form.Item
                        label="Ngày sinh"
                        name="birthday"
                    >
                        <Input disabled style={{ color: "#424242" }} />
                    </Form.Item>
                </Col>
                {!view && <Col lg={12} md={24} sm={24} style={{ textAlign: "right" }}>
                    <Button type='primary' onClick={() => setOpenModel(true)}>
                        Đổi mật khẩu
                    </Button>
                </Col>}
            </Row>
        </Form>
        {!view && <><ChangePassword openModel={openModel} setOpenModel={setOpenModel} />
        <Divider>
            Học phí đã đóng
        </Divider>
        <Tuition /></>}
    </>
}
